<script>
export default {
    name: "ApprovalModal",

    props: {

        user: Object,
        showModal: Boolean
    },

    methods: {

        approveUser() {

            this.$root.loading = true;
            this.$http.post(`Admin/ApproveUsers?Code=${this.user.code}&UserName=${this.$root.username}`)
                .then(response => {
                    this.$emit('refresh');
                    this.$root.loading = false;
                    this.$emit('closeModal');
                    window.Swal.fire({ type: 'success', title: response.data });
                }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-6/12 w-10/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Confirm Approve - {{ user.userName }}</h5>
      </template>
         <template v-slot:modal-body>
            <div class="flex flex-wrap w-full -m-3">
              
              <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-username" class="label-control">User Name:</label>
          <h5 class="text-left  text-base"> {{ user.userName }}</h5></div> 
       
      
      <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-username" class="label-control">First Name:</label>
          <h5 class="text-left text-base"> {{ user.firstName }}</h5>  </div> 
      <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-username" class="label-control">Middle Name:</label>
          <h5 class="text-left  text-base"> {{ user.secondName }}</h5>  
      </div>
      <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-username" class="label-control">Last Name:</label>
          <h5 class="text-left  text-base"> {{ user.lastName }}</h5>  </div>
      <div class="md:w-1/5 sm:w-full p-tiny">
              <label for="grid-gender" class="label-control">Gender:</label>
              <h5 class="text-left  text-base"> {{ user.gender }}</h5> 
          </div>
      
      <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-phoneno" class="label-control">Phone Number:</label>
          <h5 class="text-left  text-base"> {{ user.userPhoneNo }}</h5>   </div>
      <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-useridno" class="label-control">National Id No:</label>
          <h5 class="text-left  text-base"> {{ user.userIDNo }}</h5> </div>
                                          
          <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-useridno" class="label-control">Email:</label>
          <h5 class="text-left  text-base"> {{ user.userEmail }}</h5> </div> 
            <div class="md:w-1/5 w-1/2 p-tiny">
          <label for="grid-useridno" class="label-control">Created By:</label>
          <h5 class="text-left  text-base"> {{ user.createdBy }}</h5>  </div> 
      
       
      
        </div> 
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="approveUser"><i class="fa fa-check"></i> Approve</button>
      </template>
    </tail-modal>
</template>
